module.exports = __webpack_public_path__ + "img/15 de octubre_ConverzArte.cdd1e94b.png";